<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">CCTV Declaration form upload</p>
          </div>
        </div>
      </div>
    </section>
    <form v-if="modules.uploadCctvDocument" @submit.prevent="onSubmit" enctype="multipart/form-data" name="SaveWowKitMapping">
      <card-component>
        <template>
          <div class="columns is-mobile">
              <div class="column ">
                <div class="content">
                  <b> Validation points:<br /></b>
                  <ul>
                    <li>File size: Maximum 10MB</li>
                  </ul>
                </div>
              </div>
              <div class="column ">
                <section class="text-is-centered">
                  <b-field>
                    <b-upload v-model="dropFiles" @input="handleFileUpload" single drag-drop title="Please do upload .pdf,.png and jpeg file only">
                      <section class="section">
                        <div class="content has-text-centered">
                          <p>
                            <b-icon icon="upload" size="is-large"> </b-icon>
                          </p>
                          <p>Drop your files here or click to upload</p>
                        </div>
                      </section>
                    </b-upload>
                  </b-field>
                  <div v-if="dropFiles.name" class="tags">
                    <span class="tag is-primary">
                      {{ dropFiles.name }}
                      <button class="delete is-small" type="button" @click="deleteDropFile()"></button>
                    </span>
                  </div>
                </section>
              </div>
              <div class="column has-text-centered">
              </div>
            </div>
            <footer class="column has-text-centered">
              <button class="button is-success" type="submit">Save</button>
            </footer>
        </template>
      </card-component>
    </form>
    <div v-if="modules.DownloadDocuments">
      <v-data-table item-key="id" :items="cctvData" :footer-props="{
          'items-per-page-options': [5, 10, 20, 40]
        }" :items-per-page="10" :headers="headers">
        <template v-slot:item.documents="{ item }">
          <div>
            <v-row no-gutters>
              <v-col cols="12" md="11" class="ma-0 pa-0">
                <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" color="primary" text small
                  v-if="item.filePath" @click="openFile(item.filePath)">CCTV Document
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
            <router-link :to="{ name: 'cctvDocEdit', params: { cctvDocId: item.id } }">
              <v-btn outlined color="success" class="px-2 ml-1 ma-1" min-width="0" small>
                Edit CCTV DOC
              </v-btn>
            </router-link>
        </template>
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
      </v-data-table>
    </div>
    <loading-icon :value="isLoading" />
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import Utils from '@/utils'
import moment from 'moment'

export default {
  name: 'cctvDocUpload',
  components: {
    CardComponent
  },

  data () {
    return {
      dropFiles: [],
      allowedFormats: ['image/png', 'application/pdf', 'image/jpeg'],
      userObj: {
        cctvDocUpload: null
      },
      isLoading: false,
      headers: [
        { text: 'Name', value: 'fileName', sortable: true },
        { text: 'Uploaded Date', value: 'updatedAtDate', sortable: false },
        { text: 'Uploaded Time', value: 'updatedAtTime', sortable: false },
        { text: 'Documents', value: 'documents', sortable: false },
        ...(this.checkModuleAccess('uploadCctvDocument') ? [
          { text: 'Actions', value: 'actions', align: 'center', sortable: false }
        ] : [])
      ],
      cctvData: [],
      modules: {
        DownloadDocuments: this.checkModuleAccess('DownloadDocuments'), // listing/view document
        uploadCctvDocument: this.checkModuleAccess('uploadCctvDocument')
      }
    }
  },

  created: function () {
    this.getCctvData()
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    handleFileUpload (files) {
      this.dropFiles = files // Assign selected files to dropFiles
    },
    async onSubmit (event) {
      let that = this
      this.isLoading = true

      try {
        if (!that.dropFiles || that.dropFiles.length === 0) {
          return this.errMsg('Please select a document to upload.')
        }
        if (that.dropFiles && that.dropFiles.name) {
          const fileType = that.dropFiles.type
          const maxFileSize = 10 * 1024 * 1024 // 10 MB
          const file = that.dropFiles
          const fileSize = file.size

          if (!this.allowedFormats.includes(fileType)) {
            this.errMsg('Invalid file format. Please upload a JPG or PDF file.')
            return
          }

          if (fileSize > maxFileSize) {
            this.errMsg('File size too large. Please upload a file under 10MB.')
          }
        }
        let formData = new FormData()
        formData.append('cctvDoc', that.dropFiles)
        // if (this.cctvDocId) {
        //   await http.post(`${constants.API_URL}/api/audit/cctv-doc/update/${this.cctvDocId}`, formData)
        //   this.okMsg('CCTV Declaration Form has been successfully uploaded!')
        // } else {
        await http.post(`${constants.API_URL}/api/audit/cctv-doc/create`, formData)
        this.okMsg('CCTV Declaration Form has been successfully added!')
        this.getCctvData()
        that.dropFiles = []
        // }
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error while uploading cctv document', errorMessage)

        return this.errMsg(errorMessage)
      }
    },
    deleteDropFile () {
      this.dropFiles = []
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    openFile: async function (path) {
      if (this.modules.DownloadDocuments) {
        try {
          this.isLoading = true
          let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${path}`)
          window.open(url.data)
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(`Error While getting file details, ${errorMessage}`)
        } finally {
          this.isLoading = false
        }
      } else {
        this.errMsg('You dont have access!')
        return false
      }
    },
    getCctvData: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/audit/cctv-doc/get`)
        this.cctvData = data
        this.cctvData.map(a => {
          a.updatedAtDate = moment(a.updatedAt, 'YYYY-MM-DD').format('YYYY-MM-DD')
          a.updatedAtTime = a.updatedAt
            ? moment(a.updatedAt).format('HH:mm')
            : '-'
        })
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    }
  }

}
</script>
<style scoped>

</style>
